import { useState } from 'react';
import FormData from 'form-data';
import axios from 'axios';


function App() {

  const [file, setFile] = useState()
  const [myipfsHash, setIPFSHASH] = useState('')
 

  const handleFile=async (fileToHandle) =>{

    

    console.log('starting')

    // initialize the form data
    const formData = new FormData()

    // append the file form data to 
    formData.append("file", fileToHandle)

    // call the keys from .env

    const API_KEY = 'd4cd15ec07ce226d0189'
    const API_SECRET = 'd78010c68d3a8870e7b5284ac8ef69fc14330326a8e30dfb920490a371d8e9dd'

    // the endpoint needed to upload the file
    const url =  `https://api.pinata.cloud/pinning/pinFileToIPFS`

    const response = await axios.post(
      url,
      formData,
      {
          maxContentLength: "Infinity",
          headers: {
              "Content-Type": `multipart/form-data;boundary=${formData._boundary}`, 
              'pinata_api_key': API_KEY,
              'pinata_secret_api_key': API_SECRET

          }
      }
  ).then(
    res=>{
      console.log(res)
      setIPFSHASH(res.data.IpfsHash)
      document.querySelector('.gateway-message').innerHTML = 'Your scene has been pinned and URL generated, please copy the URL and return to the scene lazy minter'
      document.querySelector('.gateway-url').innerHTML = `https://yourmetaworld.mypinata.cloud/ipfs/${res.data.IpfsHash}`
    }
  )

  }

  

  return (
    <div>
      <div className="gateway-title">Pin Your Unity Scene</div>
      <div className="App">
      <div>
      </div>
      <div>
        <input className='upload-button' id='uploadButton' type="file" onChange={(event)=>setFile(event.target.files[0])}/>
      </div>
      <div><button className='pin-button' onClick={()=>handleFile(file)}>Pin</button></div>
      </div>
      <div className="gateway-message"></div>
      <div className='gateway-url'></div>
    </div>
  );
}

export default App;
